module.exports = __webpack_public_path__ + "static/media/Logo sgk-01.528b5033.png";